import BaseModelAPI from '../BaseModelAPI';

export default class VendorType extends BaseModelAPI {
	static entity = 'vendor type';
	static entityName = 'vendortype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}